// import Swiper JS
import Swiper from 'swiper';


export const cardSlider = () => {


	const cardSliderModules = document.querySelectorAll('.m__cslider');
	cardSliderModules.forEach((cardSliderModule) => { //Loop through each card slider and initialise swiper and buttons
		let cardSliderSwiper = cardSliderModule.querySelector('.swiper');
		let thisCSwiper = new Swiper(cardSliderSwiper, {
			slidesPerView : 1,
			centeredSlides : false,
			rewind : true,
			keyboard: {
				enabled: true,
				onlyInViewport: true,
			},
			breakpoints: {
				1200: {
					slidesPerView: 3,
				},
				768: {
					slidesPerView: 2,
				},
			}
		});

		let thisCSliderNextArrow = cardSliderModule.querySelector('.js__cslider__swiper-next');
		let thisCSliderPrevArrow = cardSliderModule.querySelector('.js__cslider__swiper-prev');

		//Move to next slide if 'next' arrow clicked
		if(thisCSliderNextArrow){
			thisCSliderNextArrow.addEventListener('click', (event) => {
				thisCSwiper.slideTo( (thisCSwiper.activeIndex + 1) );
			})
		}

		if(thisCSliderPrevArrow){
			thisCSliderPrevArrow.addEventListener('click', (event) => {
				thisCSwiper.slideTo( (thisCSwiper.activeIndex - 1) );
			})
		}

	});
	//Initialise the slider
}

